import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { getCampaignResultsPath } from '@pages/RewardsHub/CampaignsHistoryTab'
import { TradingPoolCampaignAboutModal } from '@pages/Traders-Room/Campaign-Results/Trading-Pools/TradingPoolCampaignAbout.modal'

import { useModal } from '@context/ModalsContext'

import { Body1, Title1 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { Divider } from '@ui/components/Divider'

import { CampaignType } from '@model/CampaignType'
import { TradingPoolCampaignStatus, TradingPoolTypeDto } from '@model/RewardsHubDashboardDto'

import { Box } from '@shared/components/Box'

import styles from '../TradingPoolProgress.module.scss'

export const TradingPoolPending: React.FC<{ campaign: TradingPoolTypeDto }> = ({ campaign }) => {
  const campaignStatusDrawFinished = campaign.status.id === TradingPoolCampaignStatus.ENDED
  const navigate = useNavigate()
  const { t } = useTranslation()
  const tradingPoolCampaignAbout = useModal(TradingPoolCampaignAboutModal, {
    campaignId: campaign.campaign.id,
  })

  const onClickNavigate = () => {
    navigate(
      getCampaignResultsPath(
        campaign.campaign.id,
        campaign.tradingAccount.name,
        CampaignType.TradingPool
      ),
      { replace: true }
    )
  }

  return (
    <Box flex direction='column' className={styles.tradingPoolItem} p='x24' gap='x16'>
      <Title1 color='text-high-em' semibold>
        {campaignStatusDrawFinished
          ? t('RewardsHub.TradingPool.The Draw is complete!')
          : t('RewardsHub.TradingPool.Campaign has ended!')}
      </Title1>

      {campaignStatusDrawFinished ? (
        <Box>
          <Body1 color='text-med-em'>
            {t('RewardsHub.TradingPool.Results are now available!')}
          </Body1>
        </Box>
      ) : (
        <Box flex align='center' gap='x8' wrap>
          <Body1 color='text-med-em'>
            {t('RewardsHub.TradingPool.The draw will take place shortly.')}
          </Body1>

          <Body1 color='text-purple-high-em'>{t('RewardsHub.TradingPool.Stay tuned!')}</Body1>
        </Box>
      )}

      <Divider.Horizontal />

      <Box flex direction='column' gap='x16'>
        <Box flex align='center'>
          <Box flexItem={1}>
            <Body1 color='text-med-em'>{t('RewardsHub.TradingPool.Final Prize Pool')}</Body1>
          </Box>

          <Box flexItem={1}>
            <Body1 semibold color='text-high-em'>
              ${campaign.currentPrizePool}
            </Body1>
          </Box>
        </Box>

        <Box flex align='center'>
          <Box flexItem={1}>
            <Body1 color='text-med-em'>{t('RewardsHub.TradingPool.Your entries')}</Body1>
          </Box>

          <Box flexItem={1}>
            <Body1 semibold color='text-high-em'>
              {campaign.entries}
            </Body1>
          </Box>
        </Box>
      </Box>

      <Box flex flexItem={1} align='flex-end'>
        {campaignStatusDrawFinished ? (
          <Button onClick={onClickNavigate} variant='primary' size='sm'>
            {t('RewardsHub.TradingPool.View Results')}
          </Button>
        ) : (
          <Button onClick={() => tradingPoolCampaignAbout.open()} variant='secondary' size='sm'>
            {t('RewardsHub.Learn More')}
          </Button>
        )}
      </Box>
    </Box>
  )
}
